import { createContext, useState } from "react";

export const LoaderContext = createContext(null);

export const LoaderProvider = ({ children }) => {
  const [stack, setStack] = useState(new Set());

  const startLoading = (id) => {
    setStack((prev) => new Set(prev).add(id));
  };

  const stopLoading = (id) => {
    setStack((prev) => {
      const curr = new Set(prev);
      curr.delete(id);
      return curr;
    });
  };

  const withLoader = async (fn) => {
    const id= new Date().getTime();
    startLoading(id);
    try {
      return await fn();
    } finally {
      stopLoading(id);
    }
  };

  return (
    <LoaderContext.Provider
      value={{
        startLoading,
        stopLoading,
        withLoader,
        isLoading: stack.size > 0,
      }}
    >
      {children}
    </LoaderContext.Provider>
  );
};
